import client from "./client";

const BASE = "/v1/purchase";

export const listSuppliers = async (params = {}) => (await client.get(`${BASE}/suppliers`, { params })).data;
export const createSupplier = async (body) => (await client.post(`${BASE}/suppliers`, body)).data;
export const getSupplier = async (id) => (await client.get(`${BASE}/suppliers/${id}`)).data;
export const supplierStatement = async (id, params = {}) =>
  (await client.get(`${BASE}/suppliers/${id}/statement`, { params })).data;
export const updateSupplier = async (id, body) => (await client.patch(`${BASE}/suppliers/${id}`, body)).data;
export const archiveSupplier = async (id) => (await client.delete(`${BASE}/suppliers/${id}`)).data;

export const purchaseOverview = async () => (await client.get(`${BASE}/overview`)).data;
export const listPurchaseDocs = async (params = {}) => (await client.get(`${BASE}/docs`, { params })).data;
export const createPurchaseDoc = async (body) => (await client.post(`${BASE}/docs`, body)).data;
export const getPurchaseDoc = async (id) => (await client.get(`${BASE}/docs/${id}`)).data;
export const deletePurchaseDoc = async (id) => (await client.delete(`${BASE}/docs/${id}`)).data;
export const attachSupplierInvoice = async (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await client.post(`${BASE}/docs/${id}/invoice-attachment`, fd,
    { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const openQuantities = async (id, field) =>
  (await client.get(`${BASE}/docs/${id}/open-quantities`, { params: { field } })).data;

export const docAction = async (id, action, body = {}) =>
  (await client.post(`${BASE}/actions/docs/${id}/${action}`, body)).data;
export const issueConfirmationLink = async (id) =>
  (await client.post(`${BASE}/orders/${id}/confirmation-link`)).data;
export const orderFromRequisition = async (body) =>
  (await client.post(`${BASE}/actions/orders/from-requisition`, body)).data;
export const createReceipt = async (body) => (await client.post(`${BASE}/actions/receipts`, body)).data;
export const receiptAction = async (id, action, body = {}) =>
  (await client.post(`${BASE}/actions/receipts/${id}/${action}`, body)).data;

export const billFromOrder = async (body) => (await client.post(`${BASE}/bills/from-order`, body)).data;
export const matchBill = async (id) => (await client.post(`${BASE}/bills/${id}/match`)).data;
export const postBill = async (id) => (await client.post(`${BASE}/bills/${id}/post`)).data;
export const payBill = async (id, body) => (await client.post(`${BASE}/bills/${id}/pay`, body)).data;

export const getPurchaseSettings = async () => (await client.get(`${BASE}/settings`)).data;export const savePurchaseSettings = async (body) => (await client.put(`${BASE}/settings`, body)).data;

export const purchaseAging = async (as_of) => (await client.get(`${BASE}/reports/aging`, { params: { as_of } })).data;
export const supplierPerformance = async (params = {}) =>
  (await client.get(`${BASE}/reports/performance`, { params })).data;

export const runPurchaseReport = async (kind, params = {}) =>
  (await client.get(`${BASE}/reports/run/${kind}`, { params })).data;

export const exportPurchaseReport = async (kind, format, params = {}) => {
  const res = await client.get(`${BASE}/reports/${kind}/export`, {
    params: { format, ...params },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = `purchase-${kind}.${format}`;
  link.click();
  window.URL.revokeObjectURL(url);
};
